import React, { useContext } from 'react';
import './Services.css';
import HeartEmoji from '../../img/heartemoji.png';
import Glasses from '../../img/glasses.png';
import Humble from '../../img/humble.png';
import Card from '../Card/Card';
import Resume from './Resume.pdf';
import { themeContext } from '../../Context';

const Services = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className="services" id='Services'>
        {/* left side */}
        <div className="awesome">
          <span style={{color: darkMode ? 'white' : ''}}>My Awesome</span>
          <span>Services</span>
          <span>
            Product-focused web development, automation, technical leadership, mentoring and private programming sessions.
          </span>
          <a href={Resume} download>
            <button className="button s-button">Download CV</button>
          </a>
          <div className="blur s-blur1" style={{background: "#ABF1FF94"}}></div>
        </div>
        {/* right side */}
        <div className="cards">
          <div>
            <Card emoji={HeartEmoji} heading={'Software Engineering'} detail={'Architecture, team leadership, documentation, agile delivery and scalable product decisions.'}/>
          </div>

          <div>
            <Card emoji={Glasses} heading={'Full Stack Development'} detail={'React, Angular, Node.js, NestJS, Python, Flask, FastAPI, JavaScript and TypeScript.'}/>
          </div>

          <div>
            <Card emoji={Humble} heading={'Programming Mentoring'} detail={'Private lessons, coaching, interview prep, debugging support and project guidance.'}/>
          </div>
          <div className="blur s-blur2" style={{background: "var(--purple)"}}></div>
        </div>
    </div>
  )
}

export default Services
